import React from "react";

interface CodeSnippetProps {
    language: string;
}

const CodeSnippet: React.FC<CodeSnippetProps> = ({ language }) => {
    switch (language) {
        case "Node.js":
            return (
                <code className="block whitespace-pre overflow-x-auto">
                    <span className="text-emerald-300">const</span> response = <span className="text-emerald-300">await</span> fetch(<span className="text-amber-200">"https://api.sigllm.ai/v1/chat/completions"</span>, {"{"}{"\n"}
                    {"  "}method: <span className="text-amber-200">"POST"</span>,{"\n"}
                    {"  "}headers: {"{"}{"\n"}
                    {"    "}<span className="text-amber-200">"Authorization"</span>: <span className="text-amber-200">"Bearer SIGLLM_API_KEY"</span>,{"\n"}
                    {"    "}<span className="text-amber-200">"Content-Type"</span>: <span className="text-amber-200">"application/json"</span>{"\n"}
                    {"  "}{"}"},{"\n"}
                    {"  "}body: JSON.stringify({"{"}{"\n"}
                    {"    "}model: <span className="text-amber-200">"gpt-5.2"</span>,{"\n"}
                    {"    "}messages: [{"{"} role: <span className="text-amber-200">"user"</span>, content: <span className="text-amber-200">"Route this request"</span> {"}"}]{"\n"}
                    {"  "}{"}"}){"\n"}
                    {"}"});
                </code>
            );
        case "Python":
            return (
                <code className="block whitespace-pre overflow-x-auto">
                    <span className="text-emerald-300">import</span> requests{"\n\n"}
                    response = requests.post({"\n"}
                    {"    "}<span className="text-amber-200">"https://api.sigllm.ai/v1/chat/completions"</span>,{"\n"}
                    {"    "}headers={"{"}<span className="text-amber-200">"Authorization"</span>: <span className="text-amber-200">"Bearer SIGLLM_API_KEY"</span>{"}"},{"\n"}
                    {"    "}json={"{"}{"\n"}
                    {"        "}<span className="text-amber-200">"model"</span>: <span className="text-amber-200">"gpt-5-mini"</span>,{"\n"}
                    {"        "}<span className="text-amber-200">"messages"</span>: [{"{"}<span className="text-amber-200">"role"</span>: <span className="text-amber-200">"user"</span>, <span className="text-amber-200">"content"</span>: <span className="text-amber-200">"Route this request"</span>{"}"}]{"\n"}
                    {"    "}{"}"}{"\n"}
                    )
                </code>
            );
        case "OpenAI JS":
            return (
                <code className="block whitespace-pre overflow-x-auto">
                    <span className="text-emerald-300">import</span> OpenAI <span className="text-emerald-300">from</span> <span className="text-amber-200">"openai"</span>;{"\n\n"}
                    <span className="text-emerald-300">const</span> client = <span className="text-emerald-300">new</span> OpenAI({"{"}{"\n"}
                    {"  "}apiKey: <span className="text-amber-200">"SIGLLM_API_KEY"</span>,{"\n"}
                    {"  "}baseURL: <span className="text-amber-200">"https://api.sigllm.ai/v1"</span>{"\n"}
                    {"}"});{"\n\n"}
                    <span className="text-emerald-300">const</span> response = <span className="text-emerald-300">await</span> client.chat.completions.create({"{"}{"\n"}
                    {"  "}model: <span className="text-amber-200">"gpt-5.2-mini"</span>,{"\n"}
                    {"  "}messages: [{"{"} role: <span className="text-amber-200">"user"</span>, content: <span className="text-amber-200">"Route this request"</span> {"}"}]{"\n"}
                    {"}"});
                </code>
            );
        case "OpenAI Py":
            return (
                <code className="block whitespace-pre overflow-x-auto">
                    <span className="text-emerald-300">from</span> openai <span className="text-emerald-300">import</span> OpenAI{"\n\n"}
                    client = OpenAI({"\n"}    api_key=<span className="text-amber-200">"SIGLLM_API_KEY"</span>,{"\n"}    base_url=<span className="text-amber-200">"https://api.sigllm.ai/v1"</span>{"\n"})
                    {"\n\n"}
                    response = client.chat.completions.create({"\n"}    model=<span className="text-amber-200">"gpt-5-mini"</span>,{"\n"}    messages=[{"{"}<span className="text-amber-200">"role"</span>: <span className="text-amber-200">"user"</span>, <span className="text-amber-200">"content"</span>: <span className="text-amber-200">"Route this request"</span>{"}"}]{"\n"})
                    {"\n\n"}
                    print(response.choices[0].message)
                </code>
            );
        case "cURL":
            return (
                <code className="block whitespace-pre overflow-x-auto">
                    <span className="text-emerald-300">curl</span> https://api.sigllm.ai/v1/chat/completions {"\\"}{"\n"}
                    {"  "}-H <span className="text-amber-200">"Authorization: Bearer SIGLLM_API_KEY"</span> {"\\"}{"\n"}
                    {"  "}-H <span className="text-amber-200">"Content-Type: application/json"</span> {"\\"}{"\n"}
                    {"  "}-d <span className="text-amber-200">{"'{"}</span>{"\\"}{"\n"}
                    {"    "}<span className="text-amber-200">"model"</span>: <span className="text-amber-200">"gpt-5.2-mini"</span>, {"\\"}{"\n"}
                    {"    "}<span className="text-amber-200">"messages"</span>: [<span className="text-amber-200">{"{"} "role": "user", "content": "Route this request" {"}"}</span>]{"\\"}{"\n"}
                    {"  "}<span className="text-amber-200">{"'}"}</span>
                </code>
            );
        default:
            return null;
    }
};

export default CodeSnippet;
